// Static content for Pure Space Cleaning

export const CONTACT = {
  name: "Pure Space Cleaning",
  phone: "0451 723 836",
  phoneHref: "tel:0451723836",
  email: "hello@pure-space.au",
  emailHref: "mailto:hello@pure-space.au",
  regions: ["Brisbane", "North Brisbane", "Sunshine Coast"],
};

export const SERVICES = [
  {
    id: "office",
    index: "01",
    title: "Commercial Office Cleaning",
    short: "Daily, nightly & scheduled contracts for corporate workspaces.",
    description:
      "Spotless, sanitised offices that protect your team and impress every client who walks through the door. Desk-to-ceiling detailing, high-touch disinfection and consistent nightly crews.",
    image: "https://images.pexels.com/photos/34823910/pexels-photo-34823910.jpeg",
    tags: ["Nightly service", "High-touch sanitisation", "Consumables restocking"],
  },
  {
    id: "warehouse",
    index: "02",
    title: "Warehouse & Industrial",
    short: "Large-format floor care for logistics & distribution facilities.",
    description:
      "Ride-on scrubbing, dock cleaning and dust management for warehouses of any scale. We work around your shift patterns to keep operations moving.",
    image: "https://images.pexels.com/photos/6028170/pexels-photo-6028170.jpeg",
    tags: ["Ride-on scrubbing", "Dock & bay cleaning", "Dust management"],
  },
  {
    id: "window",
    index: "03",
    title: "Window Cleaning",
    short: "Streak-free glass at ground level and at height.",
    description:
      "Internal and external glass, curtain walls and high-rise facades cleaned by fully insured, height-safety trained technicians.",
    image: "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg",
    tags: ["High-rise access", "Curtain walls", "Internal partitions"],
  },
  {
    id: "deep",
    index: "04",
    title: "Deep Cleaning",
    short: "Periodic detailed resets for offices & industrial spaces.",
    description:
      "Carpet extraction, hard-floor strip & seal, kitchen and amenity deep cleans — a full reset that returns your facility to pristine condition.",
    image: "https://images.pexels.com/photos/4239146/pexels-photo-4239146.jpeg",
    tags: ["Carpet extraction", "Strip & seal", "Amenity resets"],
  },
];

export const SERVICE_OPTIONS = [
  "Commercial Office Cleaning",
  "Warehouse & Industrial",
  "Window Cleaning",
  "Deep Cleaning",
  "Full facility programme",
];

export const PROCESS = [
  {
    num: "01",
    title: "The Assessment",
    body: "We walk your facility, map every zone and build a scope that matches your operations, compliance needs and budget.",
  },
  {
    num: "02",
    title: "The Precision",
    body: "A dedicated, police-checked crew executes to a documented checklist — colour-coded, audited and consistent every single visit.",
  },
  {
    num: "03",
    title: "The Maintenance",
    body: "Ongoing reporting, quality inspections and a single account manager keep your space immaculate month after month.",
  },
];

export const STATS = [
  { value: "12+", label: "Years operating in Brisbane" },
  { value: "1.4M", label: "Sqm cleaned annually" },
  { value: "98%", label: "Contract retention" },
  { value: "24/7", label: "Response availability" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Pure Space transformed our nightly office program. The consistency and reporting are on another level — our staff notice the difference every morning.",
    name: "Marcus Reilly",
    company: "Facilities Lead, Riverside Corporate Tower",
    meta: "9,000 sqm office",
  },
  {
    quote:
      "Their warehouse crew handles our distribution centre floors without ever slowing operations. Genuinely the most reliable contractor we've engaged.",
    name: "Priya Nand",
    company: "Operations Manager, North Coast Logistics",
    meta: "22,000 sqm warehouse",
  },
  {
    quote:
      "High-rise window and facade work delivered flawlessly and on schedule. The building has never looked sharper.",
    name: "Daniel Whitmore",
    company: "Building Manager, Sunshine Coast Business Park",
    meta: "Multi-tenant facility",
  },
];

export const GALLERY = [
  {
    id: "g1",
    label: "Warehouse floor restoration",
    before: "https://images.pexels.com/photos/6028170/pexels-photo-6028170.jpeg",
    after: "https://images.pexels.com/photos/34823910/pexels-photo-34823910.jpeg",
  },
  {
    id: "g2",
    label: "Glass & facade detailing",
    before: "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg",
    after: "https://images.pexels.com/photos/34823910/pexels-photo-34823910.jpeg",
  },
];

export const CLIENTS = [
  "CORPORATE TOWERS",
  "DISTRIBUTION CENTRES",
  "MEDICAL SUITES",
  "BUSINESS PARKS",
  "GOVERNMENT",
  "TECH CAMPUSES",
];

export const TRUST = [
  "Fully insured — $20M public liability",
  "Police-checked & inducted crews",
  "Eco-certified cleaning products",
  "ISO-aligned quality auditing",
];
